import { ApiListResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import api from '@/utils/httpClient';
import { SelectItem } from '@oncolens/oncolens-ui/lib/components/FormControls/Listbox';
import { AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { CancerConfig, DefinitionConfig } from '../configs/cancerConfig';
import { configKeys } from '../configs/config.keys';

export function getCancerConfig() {
  const config: any = { containsPHI: false };
  return api
    .get('/api/configs/cancer', config)
    .then((response) => (response.data as ApiListResponse<CancerConfig>).data);
}

export default function useCancerConfig(
  options?: UseQueryOptions<CancerConfig[], unknown, CancerConfig[], string[]>
): UseQueryResult<CancerConfig[]> {
  return useQuery(configKeys.detail('cancer'), async () => getCancerConfig(), {
    ...options,
    retry: 1,
    refetchOnWindowFocus: false
  });
}

export const getDefinitionConfig = async (type: string): Promise<DefinitionConfig[]> => {
  const config: any = { containsPHI: false };
  return api.get(`/api/definitionconfigs?Type=${type}`, config).then((res: AxiosResponse) => {
    return Promise.resolve(res.data as DefinitionConfig[]);
  });
};

type DefinitionConfigType =
	| 'Simple Staging Grading'
	| 'Treatment History'
	| 'Event History'
	| 'Risk Factor'
	| 'Test Methodology';

export function useDefinitionConfig(type: DefinitionConfigType): UseQueryResult<SelectItem[]> {
  return useQuery(configKeys.detail(type), async () =>
    getDefinitionConfig(type).then((configs) =>
      configs.map((c) => ({ label: c.value, value: c.id } as SelectItem))
    )
  );
}
